module.exports = __webpack_public_path__ + "static/media/audio-play.e31c7ce1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/icons/audio-play.svg
// module id = 361
// module chunks = 0